// removed by extract-text-webpack-plugin
module.exports = {"summaryDatesAndDetails":"summaryDatesAndDetails___1Alrh","summaryDatesAndDetails__item":"summaryDatesAndDetails__item___CMz8x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormDate/SummaryDatesAndDetails.module.scss
// module id = 2187
// module chunks = 0